import { Phone } from "lucide-react";

const CallNowButton = () => {
  return (
    <a
      href="tel:+13466378114"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 bg-gradient-to-r from-cyan-500 to-purple-600 text-white px-5 py-3 rounded-full shadow-lg shadow-cyan-500/30 hover:shadow-cyan-500/50 hover:scale-105 transition-all duration-300"
      data-testid="call-now-btn"
      aria-label="Call Now"
    >
      <Phone size={18} className="animate-pulse" />
      <span className="font-semibold text-sm">Call Now</span>
    </a>
  );
};

export default CallNowButton;
